// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Fp-z","slideIn":"Gp-z"};